import React from 'react'
import '../Styles/popup.css'

function Popup(props) {
  return props.trigger ? (
    <div className="popup">
      <div className="popup-inner">
        <button
          className="btn-close btn-close-orange close-button"
          onClick={() => props.setTrigger(false)}
          aria-label="Close"
        ></button>
        <div>{props.children}</div>
      </div>
    </div>
  ) : null
}

export default Popup
